var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 15.9998L9.33317 21.3332V17.3332H21.3332V14.6665H9.33317V10.6665L2.6665 15.9998Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3345 3.99858C15.7578 3.99421 14.196 4.30273 12.7394 4.90627C11.2829 5.5098 9.96059 6.39636 8.84912 7.51458L10.7345 9.39991C12.4971 7.63725 14.8411 6.66525 17.3345 6.66525C19.8278 6.66525 22.1718 7.63725 23.9345 9.39991C25.6971 11.1626 26.6691 13.5066 26.6691 15.9999C26.6691 18.4932 25.6971 20.8372 23.9345 22.5999C22.1718 24.3626 19.8278 25.3346 17.3345 25.3346C14.8411 25.3346 12.4971 24.3626 10.7345 22.5999L8.84912 24.4852C11.1145 26.7519 14.1278 28.0012 17.3345 28.0012C20.5411 28.0012 23.5545 26.7519 25.8198 24.4852C28.0865 22.2199 29.3358 19.2066 29.3358 15.9999C29.3358 12.7932 28.0865 9.77991 25.8198 7.51458C24.7083 6.39636 23.386 5.5098 21.9295 4.90627C20.4729 4.30273 18.9111 3.99421 17.3345 3.99858V3.99858Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign_out.d31f4765.svg";
export { ForwardRef as ReactComponent };